export type TicketStock = {
  quantity: number;
  available_quantity?: number;
  total_distributed?: number;
  reserved_quantity?: number;
};

export function ticketAvailableQuantity(ticket: TicketStock): number {
  if (typeof ticket.available_quantity === "number") {
    return Math.max(0, ticket.available_quantity);
  }

  return Math.max(0, ticket.quantity - (ticket.total_distributed ?? 0));
}

export function ticketIsSoldOut(ticket: TicketStock): boolean {
  return ticketAvailableQuantity(ticket) <= 0;
}

/** Keep sold-out tickets visible; hide never-issued zero-capacity rows. */
export function ticketShouldAppearOnEventPage(ticket: TicketStock): boolean {
  if (ticketAvailableQuantity(ticket) > 0) {
    return true;
  }

  return (
    ticket.quantity > 0 ||
    (ticket.total_distributed ?? 0) > 0 ||
    (ticket.reserved_quantity ?? 0) > 0
  );
}
